import axios from "axios";
import { toast } from 'react-toastify';

const apiRequest = async ({
    method,
    url,
    data,
    showErrorToast = true  // Option to show/hide error toast
}) => {
    let token = localStorage.getItem("token_id")
    let response = null, error = null
    let options = {
        method: method,
        url: `${process.env.REACT_APP_NODE_API_URL}${url}`,
        headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data: data
    };
    await axios(options)
        .then(res => {
            response = res
        })
        .catch(err => {
            console.log('API ERROR---', url, err)
            if (err?.response?.status === 401 && !url.includes('/checkLogin') && !url.includes('/verify-mfa') && !url.includes('/resend-mfa')) {
                localStorage.removeItem('token_id');
                window.location = '/';
                return;
            }
            error = err
            
            // Show error toast with backend message
            if (showErrorToast) {
                const errorMsg = err.response?.data?.msg || 
                                 err.response?.data?.message || 
                                 err.response?.data?.error ||
                                 err.message ||
                                 'An error occurred';
                toast.error(errorMsg);
            }
        })

    return { response, error }
}

export { apiRequest }
